import { PropertyImageUrls } from '@urbanx/agx.campaigns.client';
import { useAppSelector } from '../hooks/useAppSelector';

const usePropertyImageSelector = (): PropertyImageUrls | undefined => {
  const imagesFromFormConfig = useAppSelector((state) => state.form.propertyImageUrls);

  return imagesFromFormConfig;
};

export default usePropertyImageSelector;
